import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import type { AOVTrend } from "../../services/api";

type Props = {
  trend: AOVTrend;
};

export default function AOVTrendChart({ trend }: Props) {
  if (trend.source === "empty" || trend.points.length === 0) {
    return (
      <section className="card">
        <h2 className="card__title">📈 Średni koszyk — ostatnie {trend.period_days} dni</h2>
        <p style={{ opacity: 0.75 }}>
          Brak danych transakcyjnych — wgraj raport z Nr dokumentu, żeby zobaczyć trend AOV w czasie.
        </p>
      </section>
    );
  }

  const data = trend.points.map((p) => ({
    date: p.date.slice(5), // MM-DD
    aov: Number(p.avg_basket),
    tx: p.transactions,
  }));

  return (
    <section className="card">
      <h2 className="card__title">📈 Średni koszyk — ostatnie {trend.period_days} dni</h2>
      <div className="chart" style={{ height: 260 }}>
        <ResponsiveContainer>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e5e5" />
            <XAxis dataKey="date" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} unit=" zł" width={70} />
            <Tooltip
              formatter={(v: number) => [`${v.toFixed(2)} zł`, "Średni koszyk"]}
              labelFormatter={(l) => `Data: ${l}`}
            />
            <Line
              type="monotone"
              dataKey="aov"
              stroke="var(--color-primary, #2c5282)"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
